<div class="home">
  <div class="header">
  </div>
  <div class="content">
    <div class="content-title">
      <p>Welcome to Smart Engineering System</p>
      <p>欢迎来到智慧工程系统</p>
    </div>
    <div class="item-list">
      <div class="icon-item" *ngFor="let iconObject of iconlist">
        <div (click)="homeRouter(iconObject)">
          <app-icon [iconItem]="iconObject"></app-icon>
        </div>
      </div>
    </div>
  </div>
</div>
